import React, {Fragment, useEffect} from "react";
import {connect} from "react-redux";

import AddButton from "../PricingComponents/AddButton";
import PricingSection from "../PricingComponents/PricingSection";
import MaterialsIcons from "../../Icons/MaterialsIcons";
import {showPricingPopup} from "../pricingActions";
import PRICING_POPUP_TYPES from "../PricingPopups/pricingPopupTypes";
import PricingContext, {usePricingContext} from "../PricingContext";
import SvgIcons from "../../Icons/SvgIcons";
import {toggleFeaturesFiltersVisible} from "../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import {getPricingFeatures} from "./pricingFeaturesAsyncActions";
import PricingFeaturesList from "./PricingFeaturesList";


const PricingFeatures = (props) => {

  const {pricingFeaturesReceived, showPricingPopup, featuresFiltersVisible, getPricingFeatures, pricingFeaturesColumns,
    toggleFeaturesFiltersVisible} = props;

  const {routeParams} = usePricingContext(PricingContext);
  const {paramsGroupName} = routeParams;


  useEffect(() => {
    if (!paramsGroupName) {
      return
    }
    getPricingFeatures(paramsGroupName, pricingFeaturesColumns);
  }, [paramsGroupName, pricingFeaturesColumns]);

  const filtersClick = () => {
    toggleFeaturesFiltersVisible(!featuresFiltersVisible);
  }

  const extraPropertiesClick = () => {
    showPricingPopup(true, PRICING_POPUP_TYPES.featuresProperties);
  }

  return (
    <div className="flex-item">
      <PricingSection text={"Items"}
                      className="height-100"
                      sectionId={"pricingFeatures"}
                      leftComponents={
                        <button onClick={filtersClick}
                                className="link bold link--gray3 link--green-hover font--12 flex flex--center bg-none border-none box-shadow-none">
                          {SvgIcons.filter}
                          Filters
                        </button>
                      }
                      rightComponents={(
                        <Fragment>
                          <button onClick={extraPropertiesClick}
                                  className="link bold link--gray3 link--green-hover font--12 flex flex--center bg-none border-none box-shadow-none">
                            <span className="material-icon">{MaterialsIcons.SettingsIcon}</span>
                            <span className="margin-l3">Extra Properties</span>
                          </button>
                          <AddButton text="Add Item From Library"
                                     disabled={!paramsGroupName}
                                     onClick={() => {
                                       showPricingPopup(true, PRICING_POPUP_TYPES.assignFeatures);
                                     }}/>
                          <AddButton text="Add Blank Item"
                                     disabled={!paramsGroupName}
                                     onClick={() => {
                                       showPricingPopup(true, PRICING_POPUP_TYPES.assignFeatures);
                                     }}/>
                        </Fragment>
                      )}>
        {!paramsGroupName
          ? "No Feature Group Selected"
          : pricingFeaturesReceived
            ? <PricingFeaturesList/>
            : <div className="ui-loader ui-loader--small"/>}
      </PricingSection>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {pricingPopupOpened} = store.popups;
  const {pricingFeaturesReceived, pricingFeaturesColumns} = store.pricingState;
  const {featuresFiltersVisible} = store.featuresFiltersState;

  return {
    pricingFeaturesReceived,
    pricingPopupOpened, // update when properties changed
    featuresFiltersVisible,
    pricingFeaturesColumns,
  };
};

const mapDispatchToProps = {
  showPricingPopup,
  toggleFeaturesFiltersVisible,
  getPricingFeatures,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingFeatures);
